module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-2388w.d43b3a8a.webp";